import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AssetProps } from './Helpers';

import Card from './Card';

const Countdown = ({
  className,
  anchor,
  images,
  header,
  subHeader,
  copy,
  richTextCopy,
  links,
  align,
  verticalAlign,
  textColor,
  backgroundColor,
  date,
}) => {
  const [countdownTarget, setCountdownTarget] = useState(null);
  const parsedAlign = ['Left', 'Right'].includes(align) ? align.toLowerCase() : 'left';

  useEffect(() => {
    const dateInstance = new Date(date);
    setCountdownTarget(dateInstance);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run once
  }, []);

  const hasCountdownEnded = useMemo(() => (
    countdownTarget ? countdownTarget.getTime() <= Date.now() : false
  ), [countdownTarget]);

  return !hasCountdownEnded && (
    <section
      id={anchor || undefined}
      className={classNames('countdown', `countdown--${parsedAlign}-align`)}
    >
      <Card
        key={1}
        className="countdown__asset"
        images={images}
        backgroundColor={backgroundColor}
        textColor={textColor}
      />
      <Card
        key={2}
        className={classNames('countdown__content', className)}
        header={header}
        richTextCopy={richTextCopy}
        copy={copy}
        countdownHeader={subHeader}
        countdownTarget={countdownTarget}
        links={links}
        align={'center'}
        verticalAlign={verticalAlign}
        textColor={textColor}
        backgroundColor={backgroundColor}
      />
    </section>
  );
};

Countdown.propTypes = {
  anchor: PropTypes.string,
  copy: PropTypes.string,
  align: PropTypes.string,
  header: PropTypes.string,
  images: PropTypes.arrayOf(AssetProps),
};

export default Countdown;
